import { ColDef } from "ag-grid-community";
import { SideLoadedBusinessActionsRenderer } from "lib/agGrid/renderers/sideLoadedBusinessActionsRenderer";
import { SideLoadedBusinessIsUsedRenderer } from "lib/agGrid/renderers/sideLoadedBusinessIsUsedRenderer";

export const SideLoadedBusinessColId = {
  NAME: "ffe17918-8a30-439d-898a-b26e2ec36e99",
  ABN: "ce7b63f4-fb5d-4ec4-bdb0-240787f542fe",
  USED: "51ac6bcd-8670-4487-9ff3-79aaaebfb22f",
  ACTIONS: "6421925c-2a6b-4508-ae36-0cc873ecbea9",
};

const getUsedFilterValueGetter = (params: { data: SideLoadedBusiness }) => {
  if (params.data.businessIds?.length > 0) {
    return "Yes";
  }
  return "No";
};

export const SideLoadedBusinessColumnDef: Record<
  string,
  ColDef<SideLoadedBusiness>
> = {
  [SideLoadedBusinessColId.NAME]: {
    colId: SideLoadedBusinessColId.NAME,
    field: "name",
    headerName: "Name",
    flex: 2,
    minWidth: 180,
  },
  [SideLoadedBusinessColId.ABN]: {
    colId: SideLoadedBusinessColId.ABN,
    field: "abn",
    headerName: "ABN",
    width: 140,
  },
  [SideLoadedBusinessColId.USED]: {
    colId: SideLoadedBusinessColId.USED,
    field: "businessIds",
    headerName: "Used",
    width: 90,
    cellRenderer: SideLoadedBusinessIsUsedRenderer,
    filterValueGetter: getUsedFilterValueGetter,
  },
  [SideLoadedBusinessColId.ACTIONS]: {
    colId: SideLoadedBusinessColId.ACTIONS,
    headerName: "Actions",
    width: 100,
    pinned: "right",
    cellRenderer: SideLoadedBusinessActionsRenderer,
  },
};
